
import MeaPage from "../../../components/MeaPage";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import trainingsAPI from "../../../services/trainings";
import { Button } from "primereact/button";
import schoolsAPI from "../../../services/schools";

const RegistrationPreviewPage = () => {
  const [registrationStartDate, setRegistrationStartDate] = useState("");
  const [registrationEndDate, setRegistrationEndDate] = useState("");
  const [schoolObj, setSchoolObj] = useState(null);
  //
  const toast = useRef();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const registrationId = params.registrationId;
  const accessToken = "";

  const registrationQuery = trainingsAPI.GetOne(
    schoolId,
    registrationId,
    accessToken
  );
  const registrationObj = registrationQuery?.data?.data;
  //
  useEffect(() => {
    schoolsAPI.GetOneSchool(
      schoolId
    ).then((res) => {
      setSchoolObj(res?.data);
    });
  }, [schoolId]);
  //
  useEffect(() => {
    setRegistrationStartDate(registrationObj?.start_registration_date || "");
    setRegistrationEndDate(registrationObj?.end_registration_date || "");
  }, [registrationObj]);
  //
  return (
    <>
      <div style={{ height: "100vh" }}>
        <div className="min-h-screen flex flex-column ">
          <div className="flex flex-column flex-auto p-2">
            <div className="flex flex-column align-items-center w-full h-full">
              <div className="w-full h-full" style={{ maxWidth: '990px' }}>
                <div className="grid h-full m-0">
                  <div className="col-12 lg:col-3 mb-4 flex flex-column align-items-center ">
                    <img src={schoolObj?.avatar} alt="School Logo" className="w-8" style={{ maxWidth: '200px' }} />
                    <span className="text-lg font-medium mt-3">{schoolObj?.name}</span>
                    {schoolObj?.presentation && (
                      <p className="text-sm text-500 text-center mt-2">
                        {schoolObj.presentation}
                      </p>
                    )}
                  </div>
                  <div className="col-12 lg:col-9 mb-8">
                    <div className="surface-section px-4 py-3 md:px-6 lg:px-6">
                      <div className="flex md:align-items-center md:justify-content-between flex-column md:flex-row pb-4 border-bottom-1 surface-border">
                        <div className="mb-2 lg:mb-0">
                          <div className="text-5xl font-medium  text-900 mb-3">{registrationObj?.name}</div>
                          {registrationStartDate && registrationEndDate && (
                            <div className="text-lg mt-2">
                              <i className="pi pi-calendar mr-2"></i>
                              Période d'inscription: du{" "}
                              <span className="font-medium text-red-500">
                                {new Date(registrationStartDate).toLocaleDateString("fr-FR")}
                              </span>{" "}
                              au{" "}
                              <span className="font-medium text-red-500">
                                {new Date(registrationEndDate).toLocaleDateString("fr-FR")}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-1 mt-5">
                        <div dangerouslySetInnerHTML={{ __html: registrationObj?.registration_message }}></div>
                      </div>
                    </div>
                    <div className="surface-card px-4 py-3 md:px-6 lg:px-6 mt-4">
                      <div className="flex flex-column">
                        <div className="flex justify-content-between align-items-center mb-3">
                          <div className="text-xl font-medium">Coordonnées des parents</div>
                          <Button >
                            <i className="pi pi-pencil mr-2"></i>
                            <span className="p-button-label">Modifier</span>
                          </Button>
                        </div>
                        <div className="grid">
                          <div className="col-12 md:col-6">
                            <div className="flex flex-column gap-3">
                              <div className="flex flex-column">
                                <span className="text-500">Nom du père</span>
                                <span className="font-medium">Mohamed Ben Ali</span>
                              </div>
                              <div className="flex flex-column">
                                <span className="text-500">Email</span>
                                <span className="font-medium">parent1@email.com</span>
                              </div>
                              <div className="flex flex-column">
                                <span className="text-500">Téléphone</span>
                                <span className="font-medium">+33 661234567</span>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 md:col-6">
                            <div className="flex flex-column gap-3">
                              <div className="flex flex-column">
                                <span className="text-500">Nom de la mère</span>
                                <span className="font-medium">Fatima Zahra</span>
                              </div>
                              <div className="flex flex-column">
                                <span className="text-500">Email</span>
                                <span className="font-medium">parent2@email.com</span>
                              </div>
                              <div className="flex flex-column">
                                <span className="text-500">Téléphone</span>
                                <span className="font-medium">+33 661234568</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="surface-card px-4 py-3 md:px-6 lg:px-6 mt-4">
                      <div className="grid m-0 ">
                        {/* Left section with student info */}
                        <div className="col-12 lg:col-6 p-0 lg:pr-4 flex flex-column align-items-center lg:align-items-start">
                          <div className="flex flex-column align-items-center lg:flex-row lg:align-items-start gap-3">
                            <img
                              src="/images/user.png"
                              alt="Student avatar"
                              className="w-8rem h-8rem border-circle"
                            />
                            <div className="flex flex-column align-items-center lg:align-items-start">
                              <span className="text-xl font-medium mb-2">Ahmed Ben Ali</span>
                              <span className="text-500">Né le 12/05/2015</span>
                            </div>
                          </div>
                        </div>

                        {/* Right section with parents info and actions */}
                        <div className="col-12 lg:col-6 p-0 lg:pl-4 mt-4">
                          <div className="flex flex-column">
                            <div className="flex flex-column mb-4">
                              <div className="flex align-items-center gap-2">
                                <span className="text-500">Résultat précédent:</span>
                                <span className="font-medium text-green-500">
                                  <i className="pi pi-check-circle mr-2"></i>
                                  Réussite
                                </span>
                              </div>

                            </div>
                            {/* Action buttons */}
                            <div className="flex flex-column gap-2">
                              <Button className="p-button p-component p-button-success">
                                <span className="p-button-label">Confirmer la réinscription</span>
                              </Button>
                              <Button className="p-button p-component p-button-danger">
                                <span className="p-button-label">Désinscrire</span>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="surface-card px-4 py-3 md:px-6 lg:px-6 mt-4">
                      <div className="grid m-0 ">
                        {/* Left section with student info */}
                        <div className="col-12 lg:col-6 p-0 lg:pr-4 flex flex-column align-items-center lg:align-items-start">
                          <div className="flex flex-column align-items-center lg:flex-row lg:align-items-start gap-3">
                            <img
                              src="/images/user.png"
                              alt="Student avatar"
                              className="w-8rem h-8rem border-circle"
                            />
                            <div className="flex flex-column align-items-center lg:align-items-start">
                              <span className="text-xl font-medium mb-2">Moussa Ben Ali</span>
                              <span className="text-500">Né le 10/02/2018</span>
                            </div>
                          </div>
                        </div>

                        {/* Right section with parents info and actions */}
                        <div className="col-12 lg:col-6 p-0 lg:pl-4 mt-4">
                          <div className="flex flex-column">
                            <div className="flex flex-column mb-4">
                              <div className="flex align-items-center gap-2">
                                <span className="text-500">Résultat précédent:</span>
                                <span className="font-medium text-red-500">
                                  <i className="pi pi-exclamation-circle mr-2"></i>
                                  Redoublement
                                </span>
                              </div>

                            </div>
                            {/* Action buttons */}
                            <div className="flex flex-column gap-2">
                              <Button className="p-button p-component p-button-success">
                                <span className="p-button-label">Confirmer la réinscription</span>
                              </Button>
                              <Button className="p-button p-component p-button-danger">
                                <span className="p-button-label">Désinscrire</span>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="surface-card px-4 py-3 md:px-6 lg:px-6 mt-4">
                      <div className="grid m-0 ">
                        {/* Left section with student info */}
                        <div className="col-12 lg:col-6 p-0 lg:pr-4 flex flex-column align-items-center lg:align-items-start">
                          <div className="flex flex-column align-items-center lg:flex-row lg:align-items-start gap-3">
                            <img
                              src="/images/user.png"
                              alt="Student avatar"
                              className="w-8rem h-8rem border-circle"
                            />
                            <div className="flex flex-column align-items-center lg:align-items-start">
                              <span className="text-xl font-medium mb-2">Amina Ben Ali</span>
                              <span className="text-500">Né le 10/02/2018</span>
                            </div>
                          </div>
                        </div>

                        {/* Right section with parents info and actions */}
                        <div className="col-12 lg:col-6 p-0 lg:pl-4 mt-4">
                          <div className="flex flex-column">
                            <div className="flex flex-column mb-4">
                              <div className="flex align-items-center gap-2">
                                <span className="text-500">Résultat précédent:</span>
                                <span className="font-medium text-blue-500">
                                  <i className="pi pi-exclamation-circle mr-2"></i>
                                  en cours
                                </span>
                              </div>
                              <span className="text-sm text-500">En attente de l'avis des enseignants</span>
                            </div>
                            {/* Action buttons */}
                            <div className="flex flex-column gap-2">
                              <Button className="p-button p-component p-button-success">
                                <span className="p-button-label">Confirmer la réinscription</span>
                              </Button>
                              <Button className="p-button p-component p-button-danger">
                                <span className="p-button-label">Désinscrire</span>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {registrationObj?.registration_allow_new && <div className="card mt-4">
                      <div className="flex flex-column align-items-center p-4">
                        <h3 className="text-xl font-medium mt-0 mb-3">Ajouter une nouvelle candidature</h3>
                        <p className="text-500 text-center mb-4">
                          Vous pouvez faire une demande d'inscription pour un autre enfant en utilisant les mêmes informations de contact
                        </p>
                        <Button className="p-button p-component p-button-primary">
                          <i className="pi pi-plus mr-2"></i>
                          <span className="p-button-label">Nouvelle candidature</span>
                        </Button>
                      </div>
                    </div>}
                    {/* Main content area */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RegistrationPreviewPage;
